import { render, staticRenderFns } from "./OnboardingChooseTemplateModal.vue?vue&type=template&id=24278b14&scoped=true"
import script from "./OnboardingChooseTemplateModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseTemplateModal.vue?vue&type=style&index=0&id=24278b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24278b14",
  null
  
)

export default component.exports